import * as React from 'react'

import {makeEditable} from '@/common/utils'
import Buttons from '@/components/Buttons'
import Content from '@/components/Content'
import {Grid} from '@/components/Grid'
import Heading from '@/components/Heading'
import Images from '@/components/Images'
import Kicker from '@/components/Kicker'

const Hero = ({id, headingTag, kicker, heading, content, images, buttons, _editable}) => {
  const HeadingTag = headingTag || 'p'

  return (
    <section
      id={id ? id : undefined}
      {...makeEditable(_editable)}
      className='py-6 md:py-12 lg:py-18'
    >
      <Grid className='items-center gap-y-4'>
        <div className='col-span-full space-y-8 md:col-span-3 lg:col-span-6'>
          <HeadingTag className='space-y-6'>
            <Kicker kicker={kicker} className='block' />
            <Heading heading={heading} className='block' />
          </HeadingTag>
          <Content content={content} />

          <Buttons buttons={buttons} className='flex gap-3' />
        </div>

        <Images
          className='aspect-h-3 aspect-w-4 col-span-full md:col-span-3 lg:col-span-6'
          images={images}
          imageProps={{fitIn: true, ratio: '4:3'}}
        />
      </Grid>
    </section>
  )
}

export default Hero
